// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({2210: "StorybookV2",381: "Sandbox",4640: "GraphingCalculator",5489: "ScientificCalculator",5572: "mathlive",6587: "Dennis",7547: "Stories",8177: "Reports",}[chunkId] || chunkId) + ".chunk.js"
}